<div class="modal-header">
  <h4 class="modal-title text-center">Detail du transport</h4>
  <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="handleClick(CLOSE)">&times;</button>
</div>
<jhi-transport-card [transport]="transportView"></jhi-transport-card>
<div class="d-flex align-items-center justify-content-center flex-column mb-2">
  <button id="jhi-confirm-create-specialPlace" type="button" class="btn bary-btn btn-primary" (click)="handleClick(CLOSE)">
    <span jhiTranslate="unvalidatedBaskets.modal.actions.fermer"> </span>
  </button>
</div>
